<header class="shell-header" [class.is-sticky]="isScrolled()">
  <div class="shell-header__blur"></div>
  <div class="shell-header__bar shell-container">
    <div class="" (click)="closeMenu()">
      <img
        class="brand-logo"
        src="assets/shared/images/logo.png"
        alt="Ruffles &amp; Shine logo" />
    </div>

    <nav class="shell-header__nav" [class.is-open]="isMenuOpen()">
      <a
        class="shell-header__link"
        *ngFor="let item of navItems"
        [href]="item.href"
        (click)="closeMenu()">
        {{ item.label }}
      </a>
      <a class="shell-header__cta" href="#services" (click)="closeMenu()">Book Now</a>
    </nav>

    <button
      class="shell-header__menu"
      type="button"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="isMenuOpen()"
      (click)="toggleMenu()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</header>

<button
  class="back-to-top"
  type="button"
  aria-label="Back to top"
  [class.is-visible]="showBackToTop()"
  (click)="scrollToTop()">
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 5l-6.5 6.5 1.4 1.4L11 8.8V19h2V8.8l4.1 4.1 1.4-1.4L12 5z" />
  </svg>
</button>
